export default __webpack_public_path__ + "static/media/binoculars.eaa85214.svg";